export default function setTextAccCommentOwnerAction(commentOwner) {
    return {
        type: 'SET_COMMENT_OWNER',
        payload: commentOwner
    }
}